'use client';
import { HV2 } from '@/components/HomeV2/lib';

// Onderaan vast en klikdoorlatend: de app-shell vult het hele venster, dus een
// strook in de stroom zou de pagina laten scrollen.
export default function MirrorBannerStrip({ text }) {
  return (
    <div role="status" data-mirror-banner="1" style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 2147483000, pointerEvents: 'none',
      padding: '4px 16px', background: HV2.blue, color: '#fff', fontSize: HV2.fsText, fontWeight: 600,
      lineHeight: '18px', textAlign: 'left',
    }}>
      {text}
    </div>
  );
}
